const replaceApiVersion = (url: string, apiVersion?: string): string => {
  if (!apiVersion) {
    return url;
  }
  const removeAfter = url.indexOf('/api/');
  return url.substring(0, removeAfter + 5) + apiVersion;
};

export default replaceApiVersion;
